import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/inputs/input';
import { InputSelect } from '@/components/ui/inputs/input-select';
import { InputTextarea } from '@/components/ui/inputs/input-textarea';
import { useForm, Controller } from 'react-hook-form';
import { getSettingService, updateSettingService } from '@/services/SettingServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import PermissionCheck from '@/components/common/PermissionCheck';

const OTPPage = ({ pageTitle }) => {
    const selectRef = useRef(null);
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);
    const filedList = ['otp_type', 'otp_digit_limit', 'otp_expire_time'];
    const otpTypeOptionList = [
        // { value: 'both', label: 'Both' },
        { value: 'mail', label: 'Mail' },
        // { value: 'sms', label: 'SMS' },
    ];

    const otpDigitOptionList = [
        { value: '4', label: '4' },
        { value: '6', label: '6' },
        { value: '8', label: '8' },
    ];

    const otpExpireOptionList = [
        { value: '5', label: '5 Minutes' },
        { value: '10', label: '10 Minutes' },
        { value: '15', label: '15 Minutes' },
        { value: '20', label: '20 Minutes' },
        { value: '30', label: '30 Minutes' },
        { value: '60', label: '60 Minutes' },
    ];

    useEffect(() => {
        getDataByKey({
            key_list: filedList,
        });
    }, []);

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const getDataByKey = (keyList) => {
        setIsLoading(true);
        dispatch(getSettingService(keyList))
            .then((res) => {
                var formData = res?.data?.data;
                for (const key in formData) {
                    if (formData.hasOwnProperty(key) && formData[key] != '') {
                        setValue(key, formData[key]);
                    } else {
                        setValue(key, '');
                    }
                }
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        dispatch(updateSettingService(data))
            .then((res) => {
                getDataByKey({
                    key_list: filedList,
                });
                setIsFormSumbmit(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <Card>
            <CardHeader isBorder={true}>
                <h3 className="db-card-title">{pageTitle}</h3>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="otp_type"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'otp_type'}
                                    labelText={'Otp Type'}
                                    value={otpTypeOptionList.find((data) => data.value == getValues('otp_type')) || null}
                                    onChange={(e) => setValue('otp_type', e)}
                                    options={otpTypeOptionList}
                                    errorType={errors?.otp_type?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="otp_digit_limit"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'otp_digit_limit'}
                                    labelText={'Otp Digit Limit'}
                                    value={otpDigitOptionList.find((data) => data.value == getValues('otp_digit_limit')) || null}
                                    onChange={(e) => setValue('otp_digit_limit', e)}
                                    options={otpDigitOptionList}
                                    errorType={errors?.otp_digit_limit?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="otp_expire_time"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'otp_expire_time'}
                                    labelText={'Otp Expire Time'}
                                    value={otpExpireOptionList.find((data) => data.value == getValues('otp_expire_time')) || null}
                                    onChange={(e) => setValue('otp_expire_time', e)}
                                    options={otpExpireOptionList}
                                    errorType={errors?.otp_expire_time?.type}
                                />
                            )}
                        />
                        <PermissionCheck permsission={'update_settings'}>
                            <div className="sm:col-span-2">
                                <button type="submit" className="db-btn text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                                    <i className="lab lab-save"></i>
                                    <span>Save</span>
                                    {isFormSumbmit ? (
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </div>
                        </PermissionCheck>
                    </div>
                </form>
            </CardBody>
        </Card>
    );
};

export default OTPPage;
